import { render, staticRenderFns } from "./dashboard-red-dso.vue?vue&type=template&id=77080f86&scoped=true"
import script from "./dashboard-red-dso.vue?vue&type=script&lang=js"
export * from "./dashboard-red-dso.vue?vue&type=script&lang=js"
import style0 from "./dashboard-red-dso.vue?vue&type=style&index=0&id=77080f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77080f86",
  null
  
)

export default component.exports